"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'table.controls.export': 'Export',
    'table.controls.columns': 'Columns',
};
